<template>
  <div>
    <window-header></window-header>
    <nav-form>
      <!--<template v-slot:after>
        <button v-if="mode == 'new' || mode == 'edit'" class="button button-fill" @click="importLines">
          <fa-icon icon="file-import" />
          <span>Importar líneas</span>
        </button>
      </template>-->
      <template v-slot:actions>
        <li v-if="itemId" @click="exportarLineasCSV('albaran_id')">
          Exportar líneas
        </li>
      </template>
      <template v-slot:reports>
        <li v-for="p in (app.config.plantillas_documento_albaran_proveedor || [])" :key="'pdpc-' + p.codigo"
          @click="openURL(app.urlGeneradorInformesDocumentoPrint, { id: p.codigo, conditions: [['id', '=', itemId]] })"
          :class="{ disabled: !itemId }">
          Documento: {{ p.nombre }}
        </li>
        <li v-for="p in (app.config.plantillas_etiqueta_albaran_proveedor || [])" :key="'pdpc-' + p.codigo"
          @click="openURL(app.urlGeneradorInformesEtiquetaPrint, { id: p.codigo, conditions: [['id', '=', itemId]] })"
          :class="{ disabled: !itemId }">
          Etiquetas: {{ p.nombre }}
        </li>
      </template>
    </nav-form>
    <section>
      <article style="height: 395px">
        <field name="ndoc" widget="char" searchable label="Nº Fabricación" width="110px" style="top: 5px; left: 5px;"
          inputStyle="text-align:right;" />
        <field name="fecha" type="date" label="Fecha" width="100px" style="top: 5px; left: 130px" />
        <field autofocus ref="proveedor_id" name="proveedor_id" widget="m2o" label="Taller" searchable width="320px"
          style="top: 5px; right: 55px" labelProp="nombre_comercial" imgProp="imagen.imagen"
          :filter="[['activo', '=', 1], ['realiza_reparaciones', '=', 1]]" :fields="[
            'nacionalidad',
            { name: 'divisa_id', fields: ['codigo', 'nombre', 'ratio'] },
            { name: 'impuesto_id', fields: ['nombre', 'valor'] },
            'descuento_especial',
            'financiacion',
            { name: 'comentarios', fields: ['descripcion', 'fecha', 'activo'] },
            {
              name: 'forma_pago_id',
              fields: [
                'codigo',
                'descripcion',
                'vencimientos',
                'periodicidad',
                'periodicidad_unidades',
              ],
            },
            'descuento_linea_unidad',
            'descuento_linea_peso',
            'merma',
            'merma_linea'
          ]" />
        <a href="#" v-tooltip="'Mostrar comentarios'" class="button button-plain"
          :class="{ disabled: !formData.proveedor_id }" style="position: absolute; top: 15px; right: 22px"
          @click="mostrarComentariosProveedor">
          <fa-icon icon="sticky-note" />
        </a>
        <!--<a href="#" v-tooltip="'Abrir saldos'" class="button button-plain" :class="{ disabled: !formData.proveedor_id }"
          style="position: absolute; top: 15px; right: 5px" @click="abrirSaldos">
          <fa-icon icon="dollar-sign" />
        </a>-->
        <r-tabs ref="main-tabs" style="top: 40px; height: 353px" :wt="formData.wt" :buttons="[
          'Modelos a fabricar',
          'Pie',
        ]" :classButton="{
          disabled: !formData.proveedor_id && mode != 'search',
        }" @active="onActiveTab">
          <div class="tab">
            <field ref="lineas" name="lineas" class="lineas" :htSettings="{
              rowHeights: 15
            }" widget="handsontable" :height="152" :minRows="8" style="top: 5px; left: 4px; width: 648px"
              customprop="lineas_customprop"
              :fields="[{ name: 'sublineas', fields: ['tipo', 'codigo', 'descripcion', 'unidades', 'peso', 'v', 'margen', 'precio_coste', 'totallinea'] }]"
              :columns="[
                {
                  name: 'ean13',
                  header: '|||||||||',
                  help: 'Código de barras del artículo',
                },
                {
                  name: 'modelo_id',
                  header: 'Modelo',
                  help: 'Modelo del artículo',
                  type: 'm2o',
                  primary: 'codigo',
                  label: 'codigo',
                },
                {
                  name: 'articulo_id',
                  header: 'Artículo',
                  help: 'Código del artículo',
                  type: 'm2o',
                  primary: 'codigo',
                  label: 'codigo',
                  noOpen: true,
                  fields: [
                    { name: 'thumbnail', fields: ['imagen'] },
                    { name: 'familia_id', fields: ['codigo', 'nombre'] },
                  ],
                },
                {
                  name: 'descripcion',
                  help: 'Descripción del artículo',
                  header: 'Descripción',
                },
                /*{
                  name: 'refproveedor',
                  header: 'R. Proveedor',
                  help: 'Ref. del proveedor del artículo',
                },
                //{name:'familia_id',header:'Familia', type:'m2o', primary:'codigo', label:'codigo', readOnly:true},
                { name: 'nota', header: 'Nota' },*/
                //{name:'tt',header:'T', type:'select', options:['A','R']},
                {
                  name: 'almacen_id',
                  header: 'Almacén',
                  help: 'Almacén',
                  type: 'm2o',
                  primary: 'codigo',
                  label: 'codigo',
                  readOnly: true,
                },
                {
                  name: 'unidades',
                  header: 'Unid.',
                  help: 'Unidades',
                  type: 'numeric',
                  numericFormat: { pattern: '0,0.00' },
                },
                {
                  name: 'etiqueta',
                  help: 'Etiquetas',
                  header: 'Etiq.',
                  type: 'numeric',
                },
                {
                  name: 'peso',
                  header: 'Peso',
                  help: 'Peso',
                  type: 'numeric',
                  numericFormat: { pattern: '0,0.000' },
                },
                /*{
                  name: 'c',
                  header: 'C',
                  help: '<U> Compra por Unidad <P> Compra por Peso',
                  type: 'select',
                  options: ['U', 'P'],
                },*/
                {
                  name: 'm',
                  header: 'M',
                  help: 'Compra con Metal incluido',
                  type: 'checkbox',
                },
                /*{
                  name: 'r',
                  header: 'R',
                  help: 'Compra con Rec. equivalencia',
                  type: 'checkbox',
                },

                {
                  name: 'precio',
                  header: 'Precio',
                  help: 'Precio Compra',
                  type: 'numeric',
                  numericFormat: { pattern: '0,0.00' },
                },
                {
                  name: 'descuentos',
                  header: 'Dtos.',
                  help: 'Dto.',
                  type: 'numeric',
                  numericFormat: { pattern: '0,0.00' },
                  sufix: '%',
                },
                {
                  name: 'totallinea',
                  header: 'Total Línea',
                  help: 'Total Línea',
                  type: 'numeric',
                  numericFormat: { pattern: '0,0.00' },
                },
                {
                  name: 'm2',
                  header: 'M',
                  help: 'Marcar si se acumula el peso del metal',
                  type: 'checkbox',
                },
                {
                  name: 'c2',
                  header: 'C',
                  help: 'Marcar si se aplica Contraste por peso',
                  type: 'checkbox',
                },
                {
                  name: 'o',
                  header: 'O',
                  help: 'Marcar si se aplica Otros Costes por Peso',
                  type: 'checkbox',
                },*/
                {
                  name: 'precio_coste',
                  header: 'P. Coste',
                  help: 'Precio de coste del artículo',
                  readOnly: true,
                  type: 'numeric',
                  numericFormat: { pattern: '0,0.00' },
                },
                /*{
                  name: 'coste_fijo',
                  header: 'Coste Fijo',
                  help: 'Coste fijo por Unidad que se incrementará al coste de la pieza',
                  type: 'numeric',
                  numericFormat: { pattern: '0,0.00' },
                },
                {
                  name: 'taqueria_ids',
                  header: 'Taquería',
                  help: 'Cód. Taqueria',
                  type: 'm2m',
                  primary: 'codigo',
                  image: 'thumbnail.imagen',
                  label: 'codigo',
                  fields: ['precio_coste'],
                  filter: () => ['seccion_id', '=', 'PCK'],
                },
                {
                  name: 'taqueria_precio',
                  header: 'Taq.(€)',
                  help: 'Coste total de taqueria',
                  readOnly: true,
                  type: 'numeric',
                  numericFormat: { pattern: '0,0.00' },
                },
                {
                  name: 'incluir_taqueria',
                  header: 'P',
                  help: 'Marcar si se incrementará al coste de la pieza el precio de la taquería',
                  type: 'checkbox',
                },
                {
                  name: 'otros_costes',
                  header: 'O. Costes',
                  help: 'Otros Costes repercutidos por línea. Se incrementará al coste de la pieza',
                  readOnly: true,
                  type: 'numeric',
                  numericFormat: { pattern: '0,0.00' },
                },
                {
                  name: 'v',
                  header: 'V',
                  help: '<U> Venta por Unidad <P> Venta por Peso',
                  type: 'select',
                  options: ['U', 'P'],
                },

                {
                  name: 'm3',
                  header: 'M',
                  help: 'Venta con metal incluido',
                  type: 'checkbox',
                },*/
                {
                  name: 'margen',
                  header: '%',
                  help: '% de Margen comercial',
                  type: 'numeric',
                  numericFormat: { pattern: '0,0.00' },
                  sufix: '%',
                },
                {
                  name: 'pventa',
                  header: 'P.Venta',
                  help: 'Precio de Vta. al cliente',
                  type: 'numeric',
                  numericFormat: { pattern: '0,0.00' },
                },
                /*{
                  name: 't',
                  header: 'T',
                  help: 'Tarifa en la que se grabará el P.Venta',
                  type: 'numeric',
                  numericFormat: { pattern: '0,0' },
                },
                {
                  name: 'unidades_pendientes',
                  header: 'Uds.Pend.',
                  help: 'Unidades pendientes de facturar',
                  readOnly: true,
                  type: 'numeric',
                  numericFormat: { pattern: '0,0.00' },
                },
                {
                  name: 'peso_pendiente',
                  header: 'Peso.Pend.',
                  help: 'Peso pendiente de facturar',
                  readOnly: true,
                  type: 'numeric',
                  numericFormat: { pattern: '0,0.00' },
                },
                {
                  name: 'unidades_devueltas',
                  header: 'Uds.Dev.',
                  help: 'Unidades devueltas',
                  readOnly: true,
                  type: 'numeric',
                  numericFormat: { pattern: '0,0.00' },
                },
                {
                  name: 'peso_devuelto',
                  header: 'Peso.Dev.',
                  help: 'Peso devuelto',
                  readOnly: true,
                  type: 'numeric',
                  numericFormat: { pattern: '0,0.00' },
                },*/
              ]" />
            <field ref="sublineas" :name="`lineas.${rowSelected}.sublineas`" class="lineas"
              :readonly="rowSelected === null" :htSettings="{
                rowHeights: 15,
                cells: cellsSublineas,
              }" widget="handsontable" :height="152" :minRows="8" style="top: 156px; left: 4px; width: 648px" :columns="[
                {
                  name: 'tipo',
                  header: 'T',
                  help: '<A> Artículo/materia prima <O> Otros costes',
                  type: 'select',
                  options: ['A', 'O'],
                },
                {
                  name: 'codigo',
                  header: 'Código'
                },
                {
                  name: 'descripcion',
                  help: 'Descripción del artículo',
                  header: 'Descripción',
                  readOnly: true,
                },
                {
                  name: 'unidades',
                  header: 'Unid.',
                  help: 'Unidades',
                  type: 'numeric',
                  numericFormat: { pattern: '0,0.00' },
                },
                {
                  name: 'peso',
                  header: 'Peso',
                  help: 'Peso',
                  type: 'numeric',
                  numericFormat: { pattern: '0,0.000' },
                },
                {
                  name: 'v',
                  header: 'V',
                  help: 'Valoración a <U> Unidad o a <P> Peso',
                  type: 'select',
                  options: ['U', 'P'],
                },
                {
                  name: 'margen',
                  header: '%m',
                  help: 'Margen de beneficio en %',
                  type: 'numeric',
                  numericFormat: { pattern: '0,0.00' },
                },
                {
                  name: 'precio_coste',
                  header: 'P. Coste',
                  help: 'Precio de coste del artículo/trabajo',
                  type: 'numeric',
                  numericFormat: { pattern: '0,0.00' },
                },
                {
                  name: 'totallinea',
                  header: 'Total',
                  help: 'Total de la línea',
                  readOnly: true,
                  type: 'numeric',
                  numericFormat: { pattern: '0,0.00' },
                },
              ]" />
          </div>
          <div class="tab">
            {{ formData && formData.lineas }}
            <field name="total_unidades" widget="float" type="number" dec="2" label="Total Unidades" width="70px"
              style="top: 5px; right: 328px" :readonly="true" />
            <field name="total_peso" widget="float" type="number" dec="3" label="Total Peso" width="70px"
              style="top: 5px; right: 250px" :readonly="true" suffix=" g" />
            <field name="total_articulos" widget="float" type="number" dec="2" label="Total Artículos" inline-label
              width="70px" style="top: 10px; right: 12px" :readonly="true" />
          </div>
        </r-tabs>
        <!-- tabs -->
      </article>
    </section>
    <v-collapse-wrapper ref="main-collapse" :active="true">
      <div class="header" v-collapse-toggle>
        Listado
        <div class="item-after">
          <field widget="select" name="anio" style="position: relative; width: 100px; margin-right: 24px;" width="100"
            @click="$event.stopPropagation()" :options="years.reduce((a, v) => ({ ...a, [v]: v }), {})" searchable
            :readonly="mode != 'search'" placeholder="Todos los años" v-if="years.length" />
          {{ count }}
        </div>
      </div>
      <div class="my-content" v-collapse-content>
        <hot-table ref="hotTableComponent" :settings="htSettings"></hot-table>
      </div>
    </v-collapse-wrapper>
  </div>
</template>
<script>
import WindowMixin from "./../components/WindowMixin.vue";
import rFormMixin from "./../components/rFormMixin.vue";
import rTableMixin from "./../components/rTableMixin.vue";
import CompraMixin from "./../components/CompraMixin.js";
import FacturaMixin from "./../components/FacturaMixin.vue";

export default {
  mixins: [WindowMixin, rFormMixin, rTableMixin, CompraMixin, FacturaMixin],
  data: function () {
    var self = this;
    return {
      title: "Fabricación",
      dbAdapter: "fabricacion",
      primary: "id",
      defaultDataSearch: {
        //wt: 0,
        //anio: new Date().getFullYear(),
      },
      defaultData: {
        //wt: 0,
        fecha: new Date().yyyymmdd(),
        delegacion_id: self.app.config.delegacion_defecto || null,
        cambio: 1 //fix
      },
      sequence: { name: "fabricacion", field: "ndoc" },
      rowSelected: null
    };
  },
  mounted() {
    var self = this;

    self.$refs.lineas.field.hotInstance.addHook('afterSelectionEndByProp', function (row) {
      let h = this;
      let d = h.getSourceData()[row];
      if (d.articulo_id) {
        self.rowSelected = row;
      } else {
        self.rowSelected = null;
      }
    });

    self.$refs.sublineas.field.hotInstance.addHook('afterChange', function (changes, source) {
      if (source == 'loadData') return;
      if (!changes) return;
      var h = this;
      changes.forEach(function (change, index) {
        if (!change) return;
        var row = change[0];
        var prop = change[1];
        var oldVal = change[2];
        var newVal = change[3];
        let d = h.getSourceData()[row];
        window.console.log(row, prop, oldVal, newVal, source);

        if (prop == 'codigo' && oldVal != newVal && source != 'auto') {
          let p;
          if (d.tipo == 'A') {
            p = window.DB.getList('articulo', {
              limit: 1,
              filter: ['codigo', "=", newVal],
              depth: 3,
              fields: ['codigo', 'nombre', 'peso_unitario_fino', 'precio_coste_hechura_euros']
            })
          } else {
            p = window.DB.getList('coste_fabricacion', {
              limit: 1,
              filter: ['codigo', "=", newVal],
              depth: 3,
              fields: ['codigo', 'descripcion', 'precio']
            })
          }

          p.then(function (res) {
            if (parseInt(res.count)) {
              let a = res.data[0];
              let datarows = [
                [row, 'codigo', a.codigo],
                [row, 'descripcion', d.tipo == 'A' ? a.nombre : a.descripcion],
                [row, 'unidades', 1],
                [row, 'peso', d.tipo == 'A' ? a.peso_unitario_fino : 0],
                [row, 'v', 'U'],
                [row, 'margen', 0],
                [row, 'precio_coste', d.tipo == 'A' ? a.precio_coste_hechura_euros : a.precio],
              ];
              datarows.push([row, d.tipo == 'A' ? 'articulo_id' : 'coste_fabricacion_id', a.codigo]);
              h.setDataAtRowProp(datarows, 'auto');


            } else {
              h.setDataAtRowProp(row, prop, oldVal, 'auto');
            }
          }).catch(function (err) {
            console.error(err);
          });
        }

        if (prop == 'unidades' || prop == 'peso' || prop == 'precio' || prop == 'v' || prop == 'margen') {
          let totallinea = ((d.v == 'U' ? d.unidades : d.peso) || 0) * (d.precio_coste || 0) * (1 + ((d.margen || 0) / 100));
          window.console.log(row, prop, totallinea);
          h.setDataAtRowProp(row, 'totallinea', totallinea.toFixed(2), 'auto');
        }
      });
    });

  },
  methods: {
    cellsSublineas: function (row, col, prop) {
      const self = this;
      let cellProperties = {};
      let h = self.$refs?.sublineas?.field?.hotInstance;
      let d = h?.getSourceData()[row];

      if (h && prop != "tipo" && d && !d.tipo) {
        cellProperties.readOnly = true;
      }

      return cellProperties;
    },
    onActiveTab(i) {
      let self = this;
      switch (i) {
        case 3: //artículos
        case 4: //pie
          /*self.actualizar_total_unidades();
          self.actualizar_total_peso();*/
          break;
      }
    },
  },
};
</script>